import React, {Component} from 'react';
import StationModalForm from './StationModalForm';

class StationLinkUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {station, onUpdate} = this.props
      const updateStation = {
        ...station
      }
      const {Name, UserName, Password, MoreInfo} = values
      const addr = MoreInfo.addr
        ? MoreInfo.addr
        : ""
      const desc = MoreInfo.desc
        ? MoreInfo.desc
        : ""
      const lat = MoreInfo.lat
        ? MoreInfo.lat
        : 0
      const lng = MoreInfo.lng
        ? MoreInfo.lng
        : 0
      updateStation.Name = Name
      updateStation.UserName = UserName
      updateStation.Password = Password
      const jsonString = JSON.stringify({addr: addr, desc: desc, lat: lat, lng: lng})
      const info = btoa(unescape(encodeURIComponent(jsonString)))
      updateStation.MoreInfo = info
      onUpdate(updateStation)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {station, stations} = this.props
    const title = `Cập nhật thông tin trạm [${station.Name}]`
    return (<span>
      <a onClick={this.showModal}>
        Edit
      </a>
      <StationModalForm title={title} station={station} stations={stations} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default StationLinkUpdate;



// WEBPACK FOOTER //
// ./src/components/StationLinkUpdate.js